module.exports = __webpack_public_path__ + "img/Blue Canvas.2b5e45f3.jpg";